<template>
    <li>
        <div class="num">
            <!-- <i style="color: #59ABE3;" class="lnr lnr-apartment"></i> {{offset + index + 1}} -->
            <i style="color: #59ABE3;" class="lnr lnr-apartment"></i> {{index+1}}
        </div>
        <h4>
            <a v-bind="href" target="_blank">{{elementInfo.name_short}}</a>
        </h4>
        <p>
            <span v-bind:style="{color: status_type[0] == 1 ? '#87D37C' : '#cc0000'}">
                <i class="lnr lnr-cross-circle"></i>
                <span> {{rec_status_type_text}},</span>
            </span>
            <span> зарегистрировано {{date_start}}{{date_stop ? `, ликвидировано ${date_stop}` : ''}}</span>
        </p>
        <p v-if="name_full">Полное наименование: {{name_full}}</p>
        <p v-if="okved_bool">{{okved.code}} {{okved.descr}}</p>
        <p>
            <span style="white-space:nowrap;" v-if="ogrn">ОГРН {{ogrn}}, </span>
            <span style="white-space:nowrap;" v-if="inn">ИНН {{inn}}, </span>
            <span style="white-space:nowrap;" v-if="okpo">ОКПО {{okpo}}, </span>
            <span style="white-space:nowrap;" v-if="kpp">КПП {{kpp}}</span>
        </p>
        <p v-if="rukovod">
            <span v-if="rukovod.position">{{rukovod.position}} </span>
            <span v-if="rukovod.name" style="font-weight: 700;">{{rukovod.name}}</span>
            <span v-if="rukovod.inn" style="white-space: nowrap;"> ИНН {{rukovod.inn}}</span>
        </p>
        <p v-if="address">{{address}}</p>
        <p v-if="phones">
            <span v-for="(e,i) in phones" :key="i"><span>{{e}}</span>,&#32;</span>
        </p>
        <p v-if="emails">{{emails}}</p>
        <p v-if="sites">
            <a class="site-href" target="_blank" :href="'//'+e" v-for="(e,i) in sites" :key="i" style="margin-right: 10px;">{{e}}</a>
        </p>
        <monitoring-set-delete-button :ogrn="ogrn"></monitoring-set-delete-button>
    </li>
</template>

<script>
import monitoringSetDeleteButton from './../monitoring/monitoringSetDeleteButton.vue'
export default {
    props: [
        'elementInfo',
        'index'
    ],
    computed: {
        status_type() {
            return this.$props.elementInfo.status_type
        },
        offset(){
            const rows_per_page = this.$store.state.search.pagination.rows_per_page
            const current_page = this.$store.state.search.pagination.current_page
            return Number(rows_per_page * current_page - rows_per_page)
        },
        sites(){
            if(typeof this.$props.elementInfo.sites == 'object' && this.$props.elementInfo.sites.length) {
                return this.$props.elementInfo.sites
            }
        },
        phones(){
            if(typeof this.$props.elementInfo.phones == 'object' && this.$props.elementInfo.phones.length) {
                return this.$props.elementInfo.phones.filter((e,i) => i <= 5)
            }
        },
        emails(){
            if(typeof this.$props.elementInfo.emails == 'object' && this.$props.elementInfo.emails.length) {
                return this.$props.elementInfo.emails.filter((e,i) => i <= 5).join(', ')
            }
        },
        address(){
            return this.$props.elementInfo.address
        },
        rec_status_type_text(){
            if(this.$props.elementInfo.status_type[0] == 0){
                if(this.$props.elementInfo.rec_type == 1){
                    return "Ликвидированное юридическое лицо"
                } else {
                    return "Ликвидированный индивидуальный предприниматель"
                }
            } else if(this.$props.elementInfo.status_type[0] == 1) {
                if(this.$props.elementInfo.rec_type == 1){
                    return "Действующее юридическое лицо"
                } else {
                    return "Действующий индивидуальный предприниматель"
                }
            } else if(this.$props.elementInfo.status_type[0] == 2) {
                if(this.$props.elementInfo.rec_type == 1){
                    return "Юридическое лицо в стадии ликвидации"
                } else {
                    return "Индивидуальный предприниматель в стадии ликвидации"
                }
            }
        },
        rukovod(){
            return this.$props.elementInfo.stakeholders.filter(e=> e.type == 1)[0]
        },
        ogrn(){
            return this.$props.elementInfo.ogrn
        },
        inn(){
            return this.$props.elementInfo.inn
        },
        okpo(){
            return this.$props.elementInfo.okpo
        },
        kpp(){
            return this.$props.elementInfo.kpp
        },
        okved_bool() {
            if(this.$props.elementInfo.okved && JSON.stringify(this.$props.elementInfo.okved) != '{}' && this.$props.elementInfo.okved.code && this.$props.elementInfo.okved.descr) {
                return true
            } else {
                return false
            }
        },
        okved(){
            return this.$props.elementInfo.okved
        },
        name_full(){
            return this.$props.elementInfo.name_full
        },
        date_stop(){
            return this.$props.elementInfo.date_stop
        },
        date_start(){
            return this.$props.elementInfo.date_start
        },
        href() {
            if(this.$props.elementInfo.ogrn){
                if(this.$props.elementInfo.ogrn.length == 13){
                    return {
                        ['href']: "/company/" + this.$props.elementInfo.ogrn
                    }
                } else {
                    return {
                        ['href']: "/person/" + this.$props.elementInfo.ogrn
                    }
                }
            }
        }
    },
    components: {
        "monitoring-set-delete-button": monitoringSetDeleteButton
    }
}
</script>

<style scoped>
.site-href::after {
    content: " ";
}
li { position: relative; display: block; margin-bottom: 30px; white-space: nowrap; padding-left: 35px; }
li .num { position: absolute; top: 0; left: 0px; text-align: right; line-height: 34px; font-size: 10px; color: #9b979d;}
li h4 { font-size: 24px; margin-bottom: 7px; max-width: 30em; white-space: normal; font-weight: 400; line-height: 1.4 !important; }
li p { font-size: 14px; margin-top: 3px; white-space: normal; line-height: 1.1 !important; }

li .summary { font-size: 14px; font-weight: 400; white-space: normal; }
li .occupation { font-size: 14px; margin-top: 3px; white-space: normal; }
li .address { font-size: 14px; margin-top: 3px; white-space: normal; }
li .header { font-size: 14px; margin-top: 3px; white-space: normal; }
</style>
